import featureNames from '~/shared/constants/featureFlags';
import getHasFeature from '~/shared/utils/getHasFeature';

export default async function getServerSideRetailPriceFeature({ ctx }) {
  return getHasFeature(ctx, featureNames.RETAILPRICETEST);
}
